const kpi = {
  title: 'AKTUELLE STATISTIKEN', 
};

export default kpi;